import { Component, Input } from '@angular/core';
import { Message } from '../../../interfaces/message';
import { IconService } from 'src/app/shared/services/icon.service';
declare var window:any;

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {
  @Input() message!: Message;
  openPopup(event: MouseEvent) {
    event.preventDefault();
    window.MessagePopup.openMessagePopup(this.message.nodeId, event.currentTarget!);
  }
}
